import { createFileRoute } from '@tanstack/react-router';

import { GroupListPage } from '~pages/groups/group-list-page';

export const Route = createFileRoute('/_auth/_layout/category-config/groups')({
  component: GroupListPage,
});
